import React, { useState, useEffect } from 'react';
import { ReferAndEarnWrapper, RefferalContainer, ReferralBanner } from './styles';
import { REFER_STATUS_FILTER } from '../../utils/constants';
import CustomTabs from './custom-tabs/CustomTabs';
import ReferHistory from './refer-history/referHistory';
import { getReferralLabels, getRewardData } from './utils';
import { History, iProps } from './interface';
import { getSourceCurrencies } from '../../redux/actions/common/common-action';
import ReferCard from './refer-card/referCard';
import { formatCurrencyToTwoDecimalPlaces } from '../../utils/library';
import { EVENT_ROUTE_KEYS, EventNamesV2 } from '@Utils/events/eventsConstants';
import { logEventV2 } from '@Utils/events/logUserEvents';

const ReferAndEarn: React.FC<iProps> = ({
  referandEarnSchema,
  countryCode,
  redemptionValue,
  initialReferralInstapoint,
  transactionReferralInstapoint,
  url,
  historyData
}): React.ReactElement => {
  const [currency, setCurrency] = useState('');
  const [history, setHistory] = useState<History[]>([]);
  const [active, setActive] = useState(REFER_STATUS_FILTER[0].id);

  const filterHistory = (tabId: string) => {
    const tempHistory: History[] = historyData.filter((item) => {
      if (tabId === 'pending' && (item.status === 'Joined' || item.status === 'Code used'))
        return true;
      else if (tabId === 'completed' && item.status === 'Completed') return true;
      else if (tabId === 'all') return true;
      return false;
    });
    return tempHistory;
  };

  const getCurrency = async () => {
    if (countryCode) {
      try {
        const currency = await getSourceCurrencies(countryCode);
        setCurrency(currency?.data?.data[0]?.key);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    }
  };

  useEffect(() => {
    logEventV2(EventNamesV2.SCREEN_VIEWED, {
      pageName: EVENT_ROUTE_KEYS.ReferAndEarn
    });
  }, []);

  useEffect(() => {
    getCurrency();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode]);

  useEffect(() => {
    const tempHistory = filterHistory('pending');
    setHistory(tempHistory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [historyData]);

  const handleTabClick = (tabId: string) => {
    setActive(tabId);
    const tempHistory: History[] = filterHistory(tabId);
    setHistory(tempHistory);
  };

  const initialRedeemValue = formatCurrencyToTwoDecimalPlaces(
    redemptionValue * initialReferralInstapoint
  ).toString();
  const transactionalRedeemValue = formatCurrencyToTwoDecimalPlaces(
    redemptionValue * transactionReferralInstapoint
  ).toString();
  const initialIPValue = formatCurrencyToTwoDecimalPlaces(initialReferralInstapoint).toString();
  const labels = getReferralLabels(referandEarnSchema, countryCode);

  const rewardData = getRewardData(
    referandEarnSchema,
    currency,
    initialIPValue,
    initialRedeemValue,
    transactionalRedeemValue,
    transactionReferralInstapoint
  );

  return (
    <ReferAndEarnWrapper>
      <ReferralBanner>
        <h1 className="heading">{labels?.webPageTitle}</h1>
      </ReferralBanner>
      <RefferalContainer>
        <ReferCard
          rewardData={rewardData}
          labels={labels}
          url={url}
          currency={currency}
        ></ReferCard>
        <div className="referralActivity">
          <span className="activityText">{labels?.referralActivitySection?.heading}</span>
          <div>
            <CustomTabs tabs={REFER_STATUS_FILTER} onTabClick={handleTabClick} activeTab={active} />
          </div>
          <div>
            <ReferHistory historyData={history} labels={labels} url={url}></ReferHistory>
          </div>
        </div>
      </RefferalContainer>
    </ReferAndEarnWrapper>
  );
};

export default ReferAndEarn;
